import React from 'react';

import { IconButton } from '@atlaskit/button/new';
import CloseIcon from '@atlaskit/icon/core/close';
import MinimizeIcon from '@atlaskit/icon/core/minimize';

type MinimizeButtonProps = {
	minimizePopup: () => void;
};

type CloseButtonProps = {
	closePopup: () => void;
};

type ControlButtonProps = {
	isPlaying: boolean;
	minimizePopup: () => void;
	closePopup: () => void;
};

const MinimizeButton = ({ minimizePopup }: MinimizeButtonProps): JSX.Element => {
	return (
		<IconButton
			icon={MinimizeIcon}
			label="minimizeIcon"
			appearance="subtle"
			shape="circle"
			onClick={minimizePopup}
			testId="briefings-minimize-button"
		/>
	);
};

const CloseButton = ({ closePopup }: CloseButtonProps): JSX.Element => {
	return (
		<IconButton
			icon={CloseIcon}
			label="closeIcon"
			appearance="subtle"
			shape="circle"
			onClick={closePopup}
			testId="briefings-close-button"
		/>
	);
};

export const AudioBriefingPopupControlButton = ({
	isPlaying,
	minimizePopup,
	closePopup,
}: ControlButtonProps): JSX.Element => {
	if (isPlaying) {
		return <MinimizeButton minimizePopup={minimizePopup} />;
	}

	return <CloseButton closePopup={closePopup} />;
};
